import { inject, injectable } from "inversify";

import { LogLevel, LogSink } from "./models";
import { AbstractServiceLogger, LoggingService } from "./services";

@injectable()
export default class ServiceLogger implements AbstractServiceLogger {
  constructor(@inject(LoggingService) private loggingService: LoggingService) {}

  async push(logLevel: LogLevel, message: string) {
    if (["WARN", "ERROR", "FATAL"].includes(logLevel)) {
      try {
        this.loggingService.webLogging({ lvl: logLevel, message });
      } catch (error) {
        /** This is probably just because the user is not logged in. Ignoring. */
      }
    }
  }
}
